<template>
  <div class="login">
    <Loading v-show="loading"></Loading>
    <div class="select-os">
        <input type="radio" id="japanese" name="launguage" v-model="style" value="0" class="japanese" checked>
        <label for="japanese">
            日本語
        </label>
        <input type="radio" id="english" name="launguage" v-model="style" value="1" class="english">
        <label for="english">
            English
        </label>
    </div>
    <div id="top">
      <div v-if="style === '0'">
        <h1><img src="../assets/paper1.jpg" ></h1>
        <div class="" id="contact" style="margin-bottom: 5%;">
          <h2>お問い合わせ</h2>
          <!--<input type="text" placeholder="主催者さま名（企業・団体・Wedding）" v-model="company" required>-->
          <!--<input type="text" placeholder="団体名" v-model="institution" required>-->
          <input type="text" placeholder="お名前" v-model="name" required>
          <input type="text" placeholder="メールアドレス" v-model="mail" required>
          <input type="tel" placeholder="お電話" v-model="tel" required>
          <textarea type="text" placeholder="ご要望内容" v-model="content" required></textarea>
          
        <button id="send" @click="sendContactCertificate">お問い合わせ</button>
          <img style="width: 90%; margin-bottom: 3em;"src="../assets/footer_jp.png" >
        <br>
      </div>
      <!--<p>本サービスに関する<a href="#" style="color: #5D99FF;">利用規約</a>はこちらへ。</p>-->
      </div>

      <div v-else>
        <h1><img src="../assets/paper2.jpg" ></h1>
        <div class="" id="contact" style="margin-bottom: 5%;">
            <h2>Contact</h2>
            <!--<input type="text" placeholder="organizer(company, institution, wedding....etc)" v-model="company" required>-->
            <!--<input type="text" placeholder="institution" v-model="institution" required>-->
            <input type="text" placeholder="name" v-model="name" required>
            <input type="text" placeholder="email address" v-model="mail" required>
            <input type="tel" placeholder="tel" v-model="tel" required>
            <textarea type="text" placeholder="content" v-model="content" required></textarea>
            
          <button id="send" @click="sendContactCertificate">Contact</button>
          <img style="width: 90%; margin-bottom: 3em;"src="../assets/footer_en.png" >
          <br>
        </div>
      </div>
    </div>
    <!--<Footer/>-->
    <div class="floatMenu pcnone">
      <div v-if="style === '0'">
        <table style="width: 100%;">
          <tbody>
            <tr>
              <td style="width: 50%;"><a href="tel:03-6384-0230" class="btn-gradient-simple">電話でお問い合わせ</a></td>
              <td style="width: 50%;"><a href="#contact" class="btn-gradient-simple2">メールでお問い合わせ</a></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <table style="width: 100%;">
          <tbody>
            <tr>
              <td style="width: 50%;"><a href="tel:03-6384-0230" class="btn-gradient-simple">Tel</a></td>
              <td style="width: 50%;"><a href="#contact" class="btn-gradient-simple2">Mail</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>
<style scoped>
#top img{width: 100%;}
#top{width: 60%;
    margin: 0 auto;
    box-shadow: 1px 10px 10px rgba(0,0,0,0.4);
  }

#top input{
  display: block;
  width: 90%;
  height: 40px;
  margin: 16px auto;
  font-size: 1em;
}
h1{
 margin: 0px;
}
body{
  margin: 0px;
}
.btn-gradient-simple {
  display: inline-block;
  padding: 0.5em 1em;
  text-decoration: none;
  border-radius: 3px;
  width: 80%;
  font-size: .9em;
  font-weight: bold;
  color: #FFF;
  background-image: linear-gradient(45deg, #709dff 0%, #b0c9ff 100%);
  transition: .4s;
}

.btn-gradient-simple2 {
  display: inline-block;
  padding: 0.5em 1em;
  text-decoration: none;
  border-radius: 3px;
  font-size: .9em;
  width: 80%;
  font-weight: bold;
  color: #FFF;
  background-image: linear-gradient(45deg, #ffa500 0%, #f4a460 100%);
  transition: .4s;
}

.btn-gradient-simple:hover {
  opacity: 0.7;
}
.btn-gradient-simple2:hover {
  opacity: 0.7;
}
.floatMenu{position: fixed; bottom: 0px; left: 0px; width: 100%; background: white; box-shadow: 10px 1px 10px rgba(0,0,0,0.4);}
#top #send{
display: block;
  width: 80%;
  line-height: 40px;
  height: 40px;
  margin: 5% auto;
  text-align: center;
  font-size: 1em;
  text-align: center;
  background: #5D99FF;
  text-transform: uppercase;
  text-decoration: none;
  color: white;
  border:0px;
  border-radius: 4px;
}

#top #login:hover{
  opacity: 0.7;
}
.card-content{
  padding:8px;
  width: 100%;
  height: auto;
  background-color: white;
  margin: 0 auto;
}
textarea{
  width: 90%;
  height: 5em;
}
.login{
}
.pcnone{display: none;}
@media screen and (max-width:780px) {
#top img{width: 100%;}
#top{position: absolute;top: 6em;
    left: 0%;width: 100%;transform: initial;box-shadow: initial;margin-top: 0%;}
.card-content p{font-size: .8em;}
.login {height: 50em;}
.pcnone{display: initial;}
}
.select-os{
  text-align: center;
    margin-top: 2em;
    margin-bottom: 2em;
}
.select-os input {
  display: none;
}
.select-os input[type="radio"]:checked.japanese + label {
  color: #3275bc;
  border: 2px solid #3275bc;
  background-color: #d0e6fd;
}
.select-os input[type="radio"]:checked.english + label {
  color: #3275bc;
  border: 2px solid #3275bc;
  background-color: #d0e6fd;
}
.select-os label {
  color: #ddd;
  border: 2px solid #ddd;
  text-align: center;
  display: inline-block;
  padding: 5px 0px;
  width: 120px;
}
.select-os label:hover {
    color: #aaa;
    border: 2px solid #aaa;
    cursor: pointer;
}
</style>
<script>
import $ from 'jquery'
import Loading from './common/Loading'
import Footer from './common/Footer'
import firebase from 'firebase'
export default {
  name: 'Login',
  components: {
    Loading, Footer
  },
  data () {
    return {
      db: null,
      loading: null,
      name: null,
      mail: null,
      company: null,
      tel: null,
      hotelName: null,
      places: [],
      content: null,
      style: '0',
      mailPattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
    }
  },
  created: function () {
    this.loading = true
  },
  mounted: function () {
    this.loading = false
  },
  methods: {
    getAllPlace: function () {

    },
    sendEmail: function () {
      // プランによって送信先が違う？
      let self = this
      
            var url = null
            if (self.style === '0') {
                url = 'https://weart-marketing.com/api/contactPdf/'
            } else {
                url = 'https://weart-marketing.com/api/contactPdf/en/'
            }
            var data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'content': self.content }

            $.ajax({
              url: url,
              type: 'POST',
              data: data
            }).done(function (data) {
              if (self.style === '0') {
                   alert('お問い合わせ完了しました。')
                   self.loading = false
              } else {
                  alert('Message sent successfully.')
                  self.loading = false
              }
            }).fail(function () {
              if (self.style === '0') {
                  alert('一時的なサーバーエラーが発生しました。')
                  self.loading = false
              } else {
                  alert('System error has temporarily occurred.')
                  self.loading = false
              }
              location.href = "/error?style=" + self.style
            })
    },
    sendContactCertificate: function () {
      // コンタクトDBへ保存＆株式会社Kirarinとユーザー様へメール送信
      let self = this
      /*
      if (!this.company) {
        if (self.style === '0') {
          alert('主催者さま名（企業・団体・Wedding）が入力されていません。')
        } else {
          alert('No organizer(company, institution, wedding....etc) has been entered.Please try again.')
        }
        return
      }*/
      /*
      if (!this.institution) {
        if (self.style === '0') {
          alert('団体名が入力されていません。')
        } else {
          alert('No institution has been entered.Please try again.')
        }
        return
      }*/
      if (!this.name) {
        if (self.style === '0') {
          alert('お名前が入力されていません。')
        } else {
          alert('No name has been entered.Please try again.')
        }
        return
      }
      if (!this.mail) {
        if (self.style === '0') {
          alert('メールアドレスが入力されていません。')
        } else {
          alert('No email address has been entered.Please try again.')
        }
        return
      }
      // メールアドレスのバリデーション
      if (!this.mailPattern.test(this.mail)) {
        if (this.style === '0') {
            alert('メールアドレスの入力が正しくありません。')
        } else {
            alert('The email address is entered incorrectly.Please try again.')
        }
        return
      }
      if (!this.tel) {
        if (self.style === '0') {
          alert('電話番号が入力されてません。')
        } else {
          alert('No tel number has been entered.Please try again.')
        }
        return
      }
      var tel = this.tel.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi,'');
      if (!tel.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
        if (this.style === '0') {
            alert('電話番号の入力が正しくありません。')
            return
        } else {
            alert('The phone number is entered incorrectly.Please try again.')
            return
        }
      }
      if (!this.content) {
        if (self.style === '0') {
          alert('ご要望内容が入力されていません。')
        } else {
          alert('No content has been entered.')
        }
        return
      }
      this.loading = true
      self.sendEmail()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PDFContact.vue